import ruLocale from 'date-fns/locale/ru';
import { format } from 'date-fns';

export const getDateRangeText = (dates, formatDate = 'dd.MM.yyyy') => {
	const { startDate, endDate } = dates;
	let text = '';

	if (startDate) {
		const formattedStartDate = format(startDate, formatDate, {
			locale: ruLocale
		});
		const formattedEndDate =
			endDate && format(endDate, formatDate, { locale: ruLocale });

		text += formattedStartDate;

		if (formattedEndDate && formattedEndDate !== formattedStartDate) {
			text += `\u2013${formattedEndDate}`;
		}
	}

	return text;
};

export const weekdaysShort = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
